var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span class=\"ct-loader-wrapper\"> <div class=\"ct-loader-spinner\"> <div class=\"loader\"></div> </div> </span>";
ngModule.run(["$templateCache",function(c){c.put("loader/template/spinner.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/loader/template/spinner.html
 ** module id = 560
 ** module chunks = 1
 **/